(function() {
  function initProductAccordions() {
    var seenHeadings = {};

    document.querySelectorAll('.rte').forEach(function(rte) {
      var allChildren = Array.from(rte.children);
      var headingIndices = [];

      allChildren.forEach(function(el, i) {
        if (el.tagName !== 'P') return;
        var strongs = el.querySelectorAll('strong');
        if (strongs.length === 1 && el.textContent.trim() === strongs[0].textContent.trim() && el.textContent.trim().length > 1) {
          headingIndices.push(i);
        }
      });

      if (headingIndices.length === 0) return;

      var fragment = document.createDocumentFragment();

      allChildren.slice(0, headingIndices[0]).forEach(function(el) {
        if (!(el.tagName === 'P' && el.textContent.trim() === '')) {
          fragment.appendChild(el.cloneNode(true));
        }
      });

      headingIndices.forEach(function(hIdx, i) {
        var nextHIdx = i + 1 < headingIndices.length ? headingIndices[i + 1] : allChildren.length;
        var headingText = allChildren[hIdx].textContent.trim().toUpperCase();

        if (seenHeadings[headingText]) return;
        seenHeadings[headingText] = true;

        var contentEls = allChildren.slice(hIdx + 1, nextHIdx).filter(function(el) {
          return !(el.tagName === 'P' && el.textContent.trim() === '');
        });

        var details = document.createElement('details');
        details.className = 'product-accordion';

        var summary = document.createElement('summary');
        summary.className = 'product-accordion__summary';
        summary.innerHTML = '<span class="product-accordion__label">' + headingText + '</span><span class="product-accordion__icon" aria-hidden="true"></span>';

        var content = document.createElement('div');
        content.className = 'product-accordion__content';
        contentEls.forEach(function(el) { content.appendChild(el.cloneNode(true)); });

        details.appendChild(summary);
        details.appendChild(content);

        details.addEventListener('toggle', function() {
          if (this.open) {
            document.querySelectorAll('.product-accordion[open]').forEach(function(d) {
              if (d !== details) d.removeAttribute('open');
            });
          }
        });

        fragment.appendChild(details);
      });

      while (rte.firstChild) rte.removeChild(rte.firstChild);
      rte.appendChild(fragment);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordions);
  } else {
    initProductAccordions();
  }
})();